export const StatusCircleHalfIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="11"
      height="11"
      rx="5.5"
      stroke="currentColor"
    />
    <path
      d="M6 10C6.52529 10 7.04543 9.89654 7.53073 9.69552C8.01604 9.4945 8.45699 9.19986 8.82843 8.82843C9.19986 8.45699 9.4945 8.01604 9.69552 7.53073C9.89654 7.04543 10 6.52529 10 6C10 5.47471 9.89654 4.95457 9.69552 4.46927C9.4945 3.98396 9.19986 3.54301 8.82843 3.17157C8.45699 2.80014 8.01604 2.5055 7.53073 2.30448C7.04543 2.10346 6.52529 2 6 2L6 6L6 10Z"
      fill="currentColor"
    />
  </svg>
);
